import { isProduction } from '../../../configurations/env_config';

const INIT_CONFIG = {
    autocapture: false,
    record_mask_text_selector: "",
    record_sessions_percent: 0 // only start via start_session_recording()
};

const MIXPANEL1_TOKEN = isProduction ? '8a03ff2a8e38209c8709b7ebc9f7295b' : '942a95ab4348ac0e946d81dcab7a7046';
const MIXPANEL2_TOKEN = isProduction ? 'a56e244cb20db1b6aa4751483eddd99a' : '85844333017b7e07886a942073cffa12';

// Load the SDK separately from the initial bundle and queue calls until it is ready.
const QUEUEABLE_METHODS = [
    'identify',
    'track',
    'track_pageview',
    'start_session_recording',
    'reset',
];

// A failed chunk load must not strand the loader: loadPromise is cleared so a later call can retry, capped so a persistent failure stops retrying, and the
// queue is bounded so it cannot grow without limit while analytics is down.
const MAX_LOAD_ATTEMPTS = 3;
const MAX_PENDING = 50;

let clients = null;
let loadPromise = null;
let failedAttempts = 0;
const pending = [];

const flush = () => {
    while (pending.length) {
        const { name, method, args } = pending.shift();
        try {
            clients[name][method](...args);
        } catch (e) {
            // A queued call failing must not stop the rest of the queue draining.
        }
    }
};

const load = () => {
    if (clients) return Promise.resolve(clients);
    if (failedAttempts >= MAX_LOAD_ATTEMPTS) return Promise.resolve(null);
    if (loadPromise) return loadPromise;
    loadPromise = import(/* webpackChunkName: "mixpanel" */ 'mixpanel-browser')
        .then((mod) => {
            const mixpanel = mod.default || mod;
            clients = {
                mixpanel1: mixpanel.init(MIXPANEL1_TOKEN, INIT_CONFIG, 'mixpanel1'),
                mixpanel2: mixpanel.init(MIXPANEL2_TOKEN, INIT_CONFIG, 'mixpanel2'),
            };
            flush();
            return clients;
        })
        .catch(() => {
            // Analytics is best-effort. Drop the queue and allow a later retry.
            pending.length = 0;
            failedAttempts += 1;
            loadPromise = null;
            return null;
        });
    return loadPromise;
};

const scheduleLoad = () => {
    if (typeof window === 'undefined') return;
    if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(() => load(), { timeout: 5000 });
    } else {
        window.setTimeout(load, 2000);
    }
};
scheduleLoad();

const createClientProxy = (name) => QUEUEABLE_METHODS.reduce((proxy, method) => {
    proxy[method] = (...args) => {
        if (clients) {
            clients[name][method](...args);
            return;
        }
        if (failedAttempts >= MAX_LOAD_ATTEMPTS) return;
        pending.push({ name, method, args });
        if (pending.length > MAX_PENDING) pending.shift();
        load();
    };
    return proxy;
}, {});

export const mixpanel1 = createClientProxy('mixpanel1');
export const mixpanel2 = createClientProxy('mixpanel2');
